export class ConstantsWebservice {
  static readonly POST_INDIKATOREN_UEBERKATEGORIE_FILTERANZAHL: string =
    '/indikatoren-ueberkategorie-filteranzahl';
  static readonly POST_INDIKATOREN_ERGEBNISSE_BAUM: string =
    '/indikatoren-ergebnisse-baum';
  static readonly POST_INDIKATOREN_ERGEBNISSE_LISTE: string =
    '/indikatoren-ergebnisse-liste';
  static readonly POST_BEGLEITINDIKATOREN_LISTE: string =
    '/begleitindikatoren-ergebnisse-liste';

  static readonly POST_INDIKATOREN_ANZAHL = '/indikatoren-anzahl';

  static readonly POST_PDF_SYNOPSE: string = '/pdf-synopse';

  static readonly GET_INDIKATOREN_RICHTUNGEN: string =
    '/indikatoren-richtungen';
 
}